import { useState, useEffect } from 'react';

/**
 * Theme hook for managing light/dark mode
 * Default: light mode for business portal
 */
export function useTheme() {
  const [theme, setTheme] = useState(() => {
    // Get initial theme from localStorage or default to light
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('theme');
      // Default to light if no preference stored
      return stored === 'dark' ? 'dark' : 'light';
    }
    return 'light';
  });

  useEffect(() => {
    // Apply theme to document
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    // Persist to localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const setLightTheme = () => setTheme('light');
  const setDarkTheme = () => setTheme('dark');

  return {
    theme,
    isDark: theme === 'dark',
    isLight: theme === 'light',
    toggleTheme,
    setLightTheme,
    setDarkTheme,
    setTheme
  };
}

export default useTheme;
